/**
 * @file Album Folder Purchase Grade Tag Modal.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import withModal from '../../global/modal/withModal';
import { GRADE_TAG_FORM_MODAL } from '../../../constants/modals';
import { getAsset } from '../../../util/assets';
import Select from '../../global/Select';
import Button from '../../global/Button';
import { ALBUM_FOLDER_TAG_TYPE } from '../../../constants/album-folder-tags';
import { getTagsByType } from '../../../util/album-folder-tags';

class AlbumFolderPurchaseGradeTagModal extends Component {
  static propTypes = {
    actionProps: PropTypes.shape({
      gradeTags: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          type: PropTypes.oneOf(Object.keys(ALBUM_FOLDER_TAG_TYPE)),
        }),
      ).isRequired,
      identity: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        album_folder_tags: PropTypes.shape({
          records: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string,
              name: PropTypes.string,
              type: PropTypes.oneOf(Object.keys(ALBUM_FOLDER_TAG_TYPE)),
            }),
          ),
        }),
      }).isRequired,
    }),
    onSubmit: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    const { actionProps } = this.props;

    const { identity } = actionProps;

    const identityTags = get(identity, 'album_folder_tags.records', []);
    const identityGradeTags = getTagsByType(
      ALBUM_FOLDER_TAG_TYPE.GRADE,
      identityTags.map(identityTag => {
        return get(identityTag, 'album_folder_tag');
      }),
    );

    const identityGradeTag =
      identityGradeTags.length > 0 && identityGradeTags[0];

    this.state = {
      gradeTag: get(identityGradeTag, 'id', ''),
    };
  }

  onInputChange = event => {
    const { name } = event.target;
    const { value } = event.target;

    this.setState(() => ({ [name]: value }));
  };

  onSubmit = () => {
    if (!this.isFormValid()) {
      return;
    }

    const {
      onSubmit,
      closeModal,
      actionProps: { identity },
    } = this.props;

    const { gradeTag } = this.state;

    onSubmit(identity, gradeTag);
    closeModal(GRADE_TAG_FORM_MODAL);
  };

  isFormValid = () => {
    const { gradeTag } = this.state;

    return !!gradeTag;
  };

  render() {
    const {
      actionProps: { identity, gradeTags },
    } = this.props;

    const { gradeTag } = this.state;

    return (
      <div className="d-flex flex-column justify-content-center">
        <div className="text-center mt-3 mb-2">
          <img
            src={getAsset('/waldo-sports.png')}
            alt="Waldo logo"
            width="90"
            className="mb-2"
          />

          <h3>Is it hot in here?</h3>
          <p>
            I’m sweatin’! It’s a lot easier for me to find and deliver photos if
            you provide a bit more information.
          </p>
        </div>
        {gradeTags.length > 0 && (
          <Select
            id="level"
            name="gradeTag"
            label={`Select ${identity.name}'s grade`}
            labelNote="(required)"
            onChange={this.onInputChange}
            value={gradeTag}
            required
          >
            <option value="">Select the grade...</option>
            {gradeTags.map(tag => (
              <option key={tag.id} value={tag.id}>
                {tag.name}
              </option>
            ))}
          </Select>
        )}

        <Button
          onClick={this.onSubmit}
          disabled={!this.isFormValid()}
          className="mt-1"
        >
          Submit
        </Button>
      </div>
    );
  }
}

export default withModal(AlbumFolderPurchaseGradeTagModal, {
  name: GRADE_TAG_FORM_MODAL,
  hideHeader: true,
  size: 'sm',
  type: 'full',
});
